import { useSidebar } from '@/components/ui/sidebar';
import { Building2, CalendarDays, Menu } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export function MobileSidebarTrigger() {
  const { toggleSidebar } = useSidebar();
  const { pathname } = useLocation();

  const activeClass = "text-white bg-amber-500 rounded-lg";
  const iconWrapper = "p-2 rounded-lg transition-colors";

  const isEvents = pathname.startsWith("/events");
  const isOrganizations = pathname.startsWith("/organizations");

  return (
    <div className="sm:hidden fixed bottom-0 left-0 z-50 w-full h-14 bg-background border-b flex items-center justify-between px-4">
      <button onClick={toggleSidebar} className={iconWrapper}>
        <Menu className="h-6 w-6" />
      </button>

      <Link to="/events" className={isEvents ? `${iconWrapper} ${activeClass}` : iconWrapper}>
        <CalendarDays className="h-6 w-6" />
      </Link>

      <Link to="/organizations" className={isOrganizations ? `${iconWrapper} ${activeClass}` : iconWrapper}>
        <Building2 className="h-6 w-6" />
      </Link>
    </div>
  );
}
